<template>
    <div>
       <div class="policies-title">{{$t('PatchEasy.PatchPolicy.title')}}</div> 
       <div class="policies-top">
            <policies-search></policies-search>
       </div>
       <table-policies></table-policies>
    </div>
</template>

<script>
    import PoliciesSearch from '../policy/PoliciesSearch'
    import TablePolicies from '../policy/TablePolicies'

    export default {
        name: 'Policies',
        components: { 
            PoliciesSearch,
            TablePolicies
        }
    }
</script>

<style scoped>
    .policies-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
    }
    .policies-top
    {
        width: 100%;
        height: 53px;
    }
</style>



// WEBPACK FOOTER //
// src/components/patch_management/policy/Policies.vue